import { render, staticRenderFns } from "./OrderPreOrderIframe.vue?vue&type=template&id=383579b5&"
import script from "./OrderPreOrderIframe.vue?vue&type=script&lang=ts&"
export * from "./OrderPreOrderIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports